export var recordPerformanceMark = function(name) {
    var _performance_mark, _performance;
    (_performance_mark = (_performance = performance).mark) === null || _performance_mark === void 0 ? void 0 : _performance_mark.call(_performance, name);
};
